module.exports = __webpack_public_path__ + "static/media/markerRun.494a7dd8.svg";